import script from "./TemaApp.vue?vue&type=script&setup=true&lang=js"
export * from "./TemaApp.vue?vue&type=script&setup=true&lang=js"

import "./TemaApp.vue?vue&type=style&index=0&id=ffc1527c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffc1527c"]])

export default __exports__